import React from 'react';
import PropTypes from 'prop-types';
import { LinkFont, HoverButton } from 'modules/styled';

CircleButton.propTypes = {
  children: PropTypes.node,
  onPress: PropTypes.func,
};

export default function CircleButton({ children, onPress }) {
  return (
    <HoverButton
      sx={{
        borderWidth: 1,
        borderColor: 'blue',
        width: 9,
        height: 9,
        minWidth: [0, 0],
        borderRadius: 4 * 8,
        bg: 'white',
        pb: 2.0001,
      }}
      onPress={onPress}
    >
      <LinkFont sx={{ color: 'blue', fontSize: 3, lineHeight: 3 }}>{children}</LinkFont>
    </HoverButton>
  );
}
